import React, { useCallback, useEffect, useState } from "react";

import { Box } from "@mui/material";
import debounce from "lodash.debounce";
import { connect } from "react-redux";

import AssessmentGridView from "../../components/Assessments/AssessmentGridView";
import AssessmentLiveHeader from "../../components/Assessments/AssessmentLiveHeader";
import AssessmentTableView from "../../components/Assessments/AssessmentTableView";
import { setActionButtonToggle as setActionButtonToggleAction } from "../../redux/slices/authSlice";
import { getMyAssessments as getMyAssessmentsAction } from "../../redux/slices/myAssessmentsSlice";

/* ============================================================================
  MyAssessments
============================================================================= */
const MyAssessments = ({
  companyId,
  isCompanySetup,
  assessmentsData,
  totalAssessments,
  getMyAssessments,
  setActionButtonToggle,
}) => {
  console.log("companyId in Assesment", companyId);

  const [query, setQuery] = useState("");
  const [filter, setFilter] = useState();
  const [view, setView] = useState("list");
  const [page, setPage] = useState(1);
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    if (!isCompanySetup) {
      setActionButtonToggle(true);
      setIsLoading(false);
    } else {
      _getData({
        _page: page,
        take: rowsPerPage,
        _query: query,
        _filter: filter,
      });
    }
  }, [page]);

  useEffect(() => {
    if (assessmentsData[page]) {
      setTableData(assessmentsData[page]);
    }
  }, [assessmentsData]);

  const _getData = useCallback(
    async ({ _page, take = rowsPerPage, _query, _filter, hideLoader }) => {
      if (!hideLoader) {
        setIsLoading(true);
      }

      await getMyAssessments({
        companyId,
        take,
        page: _page,
        query: _query,
        filter: _filter,
      });

      if (!hideLoader) setIsLoading(false);
    },
    [page, query, query, filter, rowsPerPage]
  );

  const debounceFn = useCallback(
    debounce(async (value) => {
      setIsLoading(true);
      await _getData({
        _page: 1,
        _query: value,
        _filter: filter,
        take: rowsPerPage,
      });
      setIsLoading(false);
    }, 1000),
    [filter, rowsPerPage]
  );

  const _handleSearchTextChange = (value) => {
    setPage(1);
    setQuery(value);
    debounceFn(value);
  };
  const _handleFilterChange = async (value) => {
    setPage(1);
    setFilter(value);
    setIsLoading(true);
    await _getData({
      _page: 1,
      _query: query,
      _filter: value,
      take: rowsPerPage,
    });
    setIsLoading(false);
  };

  const _handleRowsPerPageChange = (event) => {
    setPage(1);
    setRowsPerPage(parseInt(event.target.value, 10));
    _getData({
      _page: 1,
      _query: query,
      _filter: filter,
      take: parseInt(event.target.value, 10),
    });
  };

  const _handleViewChange = (view) => {
    if (view === "list") setPage(1);
    setView(view);
  };

  const _handleScrollEndReach = async () => {
    setPage(page + 1);
  };

  return (
    <Box height="100%">
      <AssessmentLiveHeader
        view={view}
        query={query}
        filter={filter}
        setView={setView}
        totalAssessments={totalAssessments}
        onFilterChange={_handleFilterChange}
        onSearch={_handleSearchTextChange}
        onViewChange={_handleViewChange}
      />

      {view === "list" ? (
        <AssessmentTableView
          page={page}
          setPage={setPage}
          isLoading={isLoading}
          tableData={tableData}
          rowsPerPage={rowsPerPage}
          totalAssessments={totalAssessments}
          onRowsPerPageChange={_handleRowsPerPageChange}
        />
      ) : (
        <AssessmentGridView
          isLoading={isLoading}
          onScrollEndReach={_handleScrollEndReach}
        />
      )}
    </Box>
  );
};

const mapStateToProps = (state) => ({
  // isCompanySetup: !!state.auth?.user?.company_id,
  isCompanySetup: !!(
    state.companies?.companies?.length > 0 && state.companies.companies[0]?.id
  ),
  assessmentsData: state.myAssessments?.assessmentsData,
  totalAssessments: state?.myAssessments?.totalAssessments,
});

const mapDispatchToProps = {
  getMyAssessments: getMyAssessmentsAction,
  setActionButtonToggle: setActionButtonToggleAction,
};

/* Export
============================================================================= */
export default connect(mapStateToProps, mapDispatchToProps)(MyAssessments);

// import React, { useCallback, useEffect, useState } from "react";

// import { Box } from "@mui/material";
// import debounce from "lodash.debounce";
// import { connect } from "react-redux";

// import AssessmentGridView from "../../components/Assessments/AssessmentGridView";
// import AssessmentLiveHeader from "../../components/Assessments/AssessmentLiveHeader";
// import AssessmentTableView from "../../components/Assessments/AssessmentTableView";
// import { setActionButtonToggle as setActionButtonToggleAction } from "../../redux/slices/authSlice";
// import { getMyAssessments as getMyAssessmentsAction } from "../../redux/slices/myAssessmentsSlice";

// /* ============================================================================
//   MyAssessments
// ============================================================================= */
// const MyAssessments = ({
//   companyId,
//   isCompanySetup,
//   assessmentsData,
//   totalAssessments,
//   getMyAssessments,
//   setActionButtonToggle,
// }) => {
//   // Add debugging logs
//   console.log("MyAssessments rendered with:", {
//     companyId,
//     isCompanySetup,
//     assessmentsData,
//     totalAssessments,
//   });

//   const [query, setQuery] = useState("");
//   const [filter, setFilter] = useState();
//   const [view, setView] = useState("list");
//   const [page, setPage] = useState(1);
//   const [tableData, setTableData] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   // Fixed useEffect with proper dependencies
//   useEffect(() => {
//     console.log(
//       "useEffect triggered - isCompanySetup:",
//       isCompanySetup,
//       "companyIds:",
//       companyId
//     );

//     if (
//       !isCompanySetup ||
//       !companyId ||
//       (Array.isArray(companyId) && companyId.length === 0)
//     ) {
//       console.log("Company not setup or no companyIds, showing action button");
//       setActionButtonToggle(true);
//       setIsLoading(false);
//     } else {
//       console.log("Fetching data with params:", {
//         page,
//         rowsPerPage,
//         query,
//         filter,
//         companyIds: companyId,
//       });
//       _getData({
//         _page: page,
//         take: rowsPerPage,
//         _query: query,
//         _filter: filter,
//       });
//     }
//   }, [page, isCompanySetup, companyId]); // Added missing dependencies

//   useEffect(() => {
//     console.log("assessmentsData changed:", assessmentsData);
//     if (assessmentsData && assessmentsData[page]) {
//       setTableData(assessmentsData[page]);
//     }
//   }, [assessmentsData, page]);

//   const _getData = useCallback(
//     async ({ _page, take = rowsPerPage, _query, _filter, hideLoader }) => {
//       console.log("_getData called with:", {
//         _page,
//         take,
//         _query,
//         _filter,
//         hideLoader,
//       });

//       // Check if required data is available
//       if (!companyId || (Array.isArray(companyId) && companyId.length === 0)) {
//         console.error("Cannot fetch data: companyId is missing or empty");
//         return;
//       }

//       if (!hideLoader) {
//         setIsLoading(true);
//       }

//       try {
//         console.log(
//           "Making API call to getMyAssessments with companyIds:",
//           companyId
//         );
//         const result = await getMyAssessments({
//           companyId: companyId, // This will be array of IDs
//           companyIds: companyId, // Alternative parameter name
//           take,
//           page: _page,
//           query: _query,
//           filter: _filter,
//         });
//         console.log("API call result:", result);
//       } catch (error) {
//         console.error("Error fetching assessments:", error);
//       } finally {
//         if (!hideLoader) setIsLoading(false);
//       }
//     },
//     [companyId, getMyAssessments, rowsPerPage] // Fixed dependencies
//   );

//   const debounceFn = useCallback(
//     debounce(async (value) => {
//       console.log("Debounced search triggered with value:", value);
//       setIsLoading(true);
//       await _getData({
//         _page: 1,
//         _query: value,
//         _filter: filter,
//         take: rowsPerPage,
//       });
//       setIsLoading(false);
//     }, 1000),
//     [_getData, filter, rowsPerPage] // Use _getData in dependencies
//   );

//   const _handleSearchTextChange = (value) => {
//     console.log("Search text changed:", value);
//     setPage(1);
//     setQuery(value);
//     debounceFn(value);
//   };

//   const _handleFilterChange = async (value) => {
//     console.log("Filter changed:", value);
//     setPage(1);
//     setFilter(value);
//     setIsLoading(true);
//     await _getData({
//       _page: 1,
//       _query: query,
//       _filter: value,
//       take: rowsPerPage,
//     });
//     setIsLoading(false);
//   };

//   const _handleRowsPerPageChange = (event) => {
//     const newRowsPerPage = parseInt(event.target.value, 10);
//     console.log("Rows per page changed:", newRowsPerPage);
//     setPage(1);
//     setRowsPerPage(newRowsPerPage);
//     _getData({
//       _page: 1,
//       _query: query,
//       _filter: filter,
//       take: newRowsPerPage,
//     });
//   };

//   const _handleViewChange = (view) => {
//     console.log("View changed:", view);
//     if (view === "list") setPage(1);
//     setView(view);
//   };

//   const _handleScrollEndReach = async () => {
//     console.log("Scroll end reached, loading page:", page + 1);
//     setPage(page + 1);
//   };

//   return (
//     <Box height="100%">
//       <AssessmentLiveHeader
//         view={view}
//         query={query}
//         filter={filter}
//         setView={setView}
//         totalAssessments={totalAssessments}
//         onFilterChange={_handleFilterChange}
//         onSearch={_handleSearchTextChange}
//         onViewChange={_handleViewChange}
//       />

//       {view === "list" ? (
//         <AssessmentTableView
//           page={page}
//           setPage={setPage}
//           isLoading={isLoading}
//           tableData={tableData}
//           rowsPerPage={rowsPerPage}
//           totalAssessments={totalAssessments}
//           onRowsPerPageChange={_handleRowsPerPageChange}
//         />
//       ) : (
//         <AssessmentGridView
//           isLoading={isLoading}
//           onScrollEndReach={_handleScrollEndReach}
//         />
//       )}
//     </Box>
//   );
// };

// const mapStateToProps = (state) => {
//   // Get all company IDs instead of just first one
//   const companyIds =
//     state.companies?.companies?.map((company) => company.id).filter(Boolean) ||
//     [];

//   const mappedState = {
//     companyId: companyIds, // Pass array of all company IDs
//     companyIds: companyIds, // Alternative prop name if needed
//     isCompanySetup: !!(
//       state.companies?.companies?.length > 0 && state.companies.companies[0]?.id
//     ),
//     assessmentsData: state.myAssessments?.assessmentsData,
//     totalAssessments: state?.myAssessments?.totalAssessments,
//   };

//   console.log("mapStateToProps result:", mappedState);
//   console.log("All company IDs:", companyIds);
//   console.log("Full companies state:", state.companies);
//   return mappedState;
// };

// const mapDispatchToProps = {
//   getMyAssessments: getMyAssessmentsAction,
//   setActionButtonToggle: setActionButtonToggleAction,
// };

// /* Export
// ============================================================================= */
// export default connect(mapStateToProps, mapDispatchToProps)(MyAssessments);
